// src/pages/Center Admin/Nurse1DashboardPage.tsx
import React from "react";
import InfoItem from "../../../components/Center Admin/Reuse/InfoItem";
import StatCard from "../../../components/Center Admin/Reuse/StatCard";
import "../../../center admin css/welcome.css";
import "../../../center admin css/centerAdmin.css";
// import "@fontsource/montserrat";

import { ReactComponent as BuildingIcon } from "../../../assets/icons/building.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar.svg";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock.svg";
import { ReactComponent as ChartIcon } from "../../../assets/icons/bar-chart.svg";
import { ReactComponent as RightIcon } from "../../../assets/icons/right-tick.svg";
import { ReactComponent as SandIcon } from "../../../assets/icons/sand-clock.svg";

import {
  ICenterConfig,
  IScheduleDetails,
} from "../../Center Admin/WelcomeScreenPage";
import { IScreeningCounts } from "./Nurse1DashboardApi"; // type-only, OK

interface Nurse1DashboardProps {
  userName: string;
  isLoading: boolean;
  error: string | null;
  centerConfig?: ICenterConfig | null;
  scheduleDetails?: IScheduleDetails | null;
  screeningCounts?: IScreeningCounts | null;
  // totalScreeningDays?: number;
}

const getDayName = (): string =>
  new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(new Date());

const getTodayDateString = (): string =>
  new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date());

const Nurse1DashboardPage: React.FC<Nurse1DashboardProps> = ({
  userName,
  isLoading,
  error,
  centerConfig,
  scheduleDetails,
  screeningCounts,
  // totalScreeningDays,
}) => {
  const todayDayName = getDayName();
  const todayDate = getTodayDateString();
  const todaysSlotDesign =
    scheduleDetails?.slotDesigns?.[todayDayName] ?? "Not Scheduled Today";

  return (
    <section className="audio-main" data-page="nurse1-dashboard">
      <div className="audio-welcome-card">
        <div className="intro__title">Welcome {userName}!</div>
        <div className="audio-welcome-sub">You are the Nurse 1 today.</div>
      </div>

      <div className="audio-card-nurse">
        <div className="card__title">Screening Center Details</div>
        {error && <div className="error-message">{error}</div>}
        {!error && (
          <div className="details-grid">
            <InfoItem
              label="Center Name"
              value={isLoading ? "..." : centerConfig?.centerName || "---"}
              icon={<BuildingIcon width={24} height={24} fill="#00A8A8" />}
            />
            <InfoItem
              label="Screening Date"
              value={isLoading ? "..." : todayDate}
              icon={<CalendarIcon width={24} height={24} fill="#00A8A8" />}
            />
            <InfoItem
              label="Slot Design"
              value={isLoading ? "..." : todaysSlotDesign}
              icon={<CalendarIcon width={24} height={24} fill="#00A8A8" />}
            />
            {/* <InfoItem
              label="Screening Start Date"
              value={
                isLoading ? "..." : scheduleDetails?.screeningStartDate || "---"
              }
              icon={<ClockIcon width={24} height={24} fill="#00A8A8" />}
            />
            <InfoItem
              label="Screening End Date" 
              value={
                isLoading ? "..." : scheduleDetails?.screeningEndDate || "---"
              }
              icon={<ClockIcon width={24} height={24} fill="#00A8A8" />}
            />
            <InfoItem
              label="Total Screenings Scheduled"
              value={isLoading ? "..." : (scheduleDetails?.totalScreeningDays?.toString() ?? "---")}
              icon={<ChartIcon width={24} height={24} fill="#00A8A8" />}
            /> */}
          </div>
        )}
      </div>
      <div className="audio-kpi-grid">
        <StatCard
          value={isLoading ? "..." : (screeningCounts?.totalBookingsToday ?? 0)}
          label="Today's Appointments"
          icon={<ChartIcon width={24} height={24} fill="#00A8A8" />}
        />

        <StatCard
          value={
            isLoading ? "..." : (screeningCounts?.totalCompletedToday ?? 0)
          }
          label="Completed Screenings"
          icon={<RightIcon width={24} height={24} fill="#00A8A8" />}
        />

        <StatCard
          value={isLoading ? "..." : (screeningCounts?.totalPendingToday ?? 0)}
          label="Pending Screenings"
          icon={<SandIcon width={24} height={24} fill="#00A8A8" />}
        />
      </div>
    </section>
  );
};

export default Nurse1DashboardPage;
